module.exports = __webpack_public_path__ + "static/media/play_overlay.3895b9af.svg";